import { render, staticRenderFns } from "./AtomFloatingButton.vue?vue&type=template&id=dc54e498&"
import script from "./AtomFloatingButton.vue?vue&type=script&lang=js&"
export * from "./AtomFloatingButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports